import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

import { CustomError } from "~/common/types/errorTypes";
import { CreateNewPharmacyFormValuesType } from "~/common/types/pharmacyForm";
import { getPatientPharmaciesApi } from "./getPatientPharmaciesApi";
import { patientPharmaciesQueryKey } from "./patientPharmaciesQueryKey";

interface MutationFunctionProps {
  pharmacy: CreateNewPharmacyFormValuesType;
  pharmacyId: string;
}

export const useUpdatePatientPharmacy = (
  handleCloseModal: () => void,
  patientId?: string,
) => {
  const queryClient = useQueryClient();
  const api = getPatientPharmaciesApi(patientId);

  const { mutate: updatePatientPharmacyMutation, isPending } = useMutation({
    mutationFn: ({ pharmacy, pharmacyId }: MutationFunctionProps) =>
      api.updatePharmacy(pharmacy, pharmacyId),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: patientPharmaciesQueryKey(patientId),
      });
      handleCloseModal();
    },
    onError: (error: CustomError) => {
      const customError = error.response.data.detail;
      toast.error(customError ?? "Something went wrong, try again later!");
    },
  });

  return { updatePatientPharmacyMutation, isPending };
};
